<div class="otp-input-container">
  <div class="otp-box">
    <input
      *ngFor="let value of otpValues; let i = index; trackBy: trackByIndex"
      #otpInput
      [type]="inputType"
      [ngClass]="{ error: hasError }"
      [attr.data-index]="i"
      inputmode="numeric"
      maxlength="1"
      autocomplete="off"
      autocomplete="one-time-code"
      class="otp-input"
      (input)="onInput($event, i)"
      (keydown)="onKeyDown($event, i)"
      (paste)="onPaste($event, i)"
    />
  </div>
</div>
